import * as FileDrop from "./FileDrop"
export default FileDrop;